import Handlebars from "handlebars-template-loader/runtime";
import ternary from "handlebars-helper-ternary";

Handlebars.registerHelper("ternary", ternary);
